/**
 * Distorts points towards a star-like square shape
 * @param {number} x - X coordinate
 * @param {number} y - Y coordinate
 * @param {number} width - Canvas width
 * @param {number} height - Canvas height
 * @returns {Object} Distorted point {x, y}
 */
export const squareStarDistortion = (x, y, width, height) => {
  if (x === undefined || y === undefined) return { x, y };
  const centerX = width / 2;
  const centerY = height / 2;

  // Calculate normalized position (0-1) relative to the center
  const normalizedX = x / width;
  const normalizedY = y / height;

  // Calculate how much to distort (more in center, less at edges)
  const distortFactor = 0.3 * (1 - Math.abs(normalizedX - 0.5) * 2) * (1 - Math.abs(normalizedY - 0.5) * 2);

  // Calculate direction to nearest edge
  let dirX = x < centerX ? -1 : 1;
  let dirY = y < centerY ? -1 : 1;

  // Apply distortion - push towards edges based on location
  let newX = x + dirX * distortFactor * centerX;
  let newY = y + dirY * distortFactor * centerY;

  return { x: newX, y: newY };
};